import styled from 'styled-components';
// import { color } from 'styles/pallete';

export const container = styled.div`
	width: 50vw;
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: center;
	gap: 1.5rem;

	@media (max-width: 500px) {
		width: 100%;
	}
`;
